import { useState, useCallback } from 'react'

const useBoolean = (initialValue: any) => {
  const [value, setValue] = useState<boolean>(!!initialValue)
  const setTrue = useCallback(() => setValue(true), [])
  const setFalse = useCallback(() => setValue(false), [])
  const toggleValue = useCallback(() => setValue((previousBoolean) => !previousBoolean), [])

  return [value, setTrue, setFalse, toggleValue, setValue] as const
}

export default useBoolean
